import React from "react";

const AVATAR_COLORS = [
  "#4F46E5",
  "#EA580C",
  "#16A34A",
  "#DC2626",
  "#2563EB",
  "#7C3AED",
];

const getInitials = (name) => {
  const clean = typeof name === "string" ? name.trim() : "";
  if (!clean || clean === "-") return "?";
  const parts = clean.split(/\s+/);
  const first = parts[0].charAt(0);
  const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : "";
  return `${first}${last}`.toUpperCase();
};

const getAvatarColor = (name) => {
  const clean = typeof name === "string" && name.trim() ? name.trim() : "A";
  return AVATAR_COLORS[clean.charCodeAt(0) % AVATAR_COLORS.length];
};

const InitialsAvatar = ({
  src,
  name,
  size,
  shape,
  className,
  style,
  alt,
}) => {
  const sizeStyle = size ? { width: size, height: size } : {};
  const radius =
    shape === "square"
      ? "5px"
      : shape === "circle" || !className
        ? "50%"
        : undefined;

  if (src) {
    return (
      <img
        src={src}
        alt={alt || name || "avatar"}
        className={className}
        style={{
          ...sizeStyle,
          ...(radius && { borderRadius: radius }),
          ...(!className && { objectFit: "cover" }),
          ...style,
        }}
      />
    );
  }

  return (
    <span
      className={className}
      style={{
        ...sizeStyle,
        ...(radius && { borderRadius: radius }),
        background: getAvatarColor(name),
        color: "#fff",
        fontWeight: 700,
        fontSize: size ? Math.max(10, Math.round(size * 0.4)) : undefined,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        lineHeight: 1,
        userSelect: "none",
        ...style,
      }}
    >
      {getInitials(name)}
    </span>
  );
};

export { getInitials, getAvatarColor };
export default InitialsAvatar;
